export const getMutatedEntries = (ref, obj) => {
  let result = {};
  for (let [key, value] of Object.entries(obj)) {
    if (key in ref) {
      if (typeof value === "object" && value !== null) {
        let subResult = getMutatedEntries(ref[key], value);
        if (Object.keys(subResult).length !== 0) {
          result[key] = subResult;
        }
      } else {
        if (value !== ref[key]) {
          result[key] = value;
        }
      }
    }
  }

  return result;
};

export const hexToRGB = (hex) => {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : null;
};

export const colorBrightness = (hexColor) => {
  let [red, green, blue] = hexToRGB(hexColor);

  let brightness = Math.round(
    (parseInt(red) * 299 + parseInt(green) * 587 + parseInt(blue) * 114) / 1000
  );

  return brightness;
};

export const isBright = (hexColor) => colorBrightness(hexColor) > 150;
